

























import { defineComponent, onMounted, ref, useContext } from '@nuxtjs/composition-api';
import { useWebsiteCode } from '~/composables';

const COOKIE_CONSENT_NAME = 'togas-cookie-consent';

export default defineComponent({
  name: 'CookieBanner',
  setup() {
    const { app } = useContext();
    const { isRu } = useWebsiteCode();
    const isVisible = ref(false);
    const policyLink = '/ru/serviceonline/legal_information/#privacy-policy';
    const recommendationTechnologiesLink = '/ru/serviceonline/legal_information/#recommendation-technologies';

    const acceptCookies = () => {
      app.$cookies.set(COOKIE_CONSENT_NAME, '1', {
        path: '/',
        maxAge: 60 * 60 * 24 * 365,
      });
      isVisible.value = false;
    };

    onMounted(() => {
      isVisible.value = !app.$cookies.get(COOKIE_CONSENT_NAME);
    });

    return {
      isVisible,
      policyLink,
      recommendationTechnologiesLink,
      acceptCookies,
      isRu,
    };
  },
});
